export default "__VITE_ASSET__Fd_3A$6X__"